import { render, staticRenderFns } from "./Comprobaciones.vue?vue&type=template&id=5a483423&scoped=true&"
import script from "./Comprobaciones.vue?vue&type=script&lang=js&"
export * from "./Comprobaciones.vue?vue&type=script&lang=js&"
import style0 from "./Comprobaciones.vue?vue&type=style&index=0&id=5a483423&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a483423",
  null
  
)

export default component.exports